import script from "./SelectCompaniesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCompaniesDialog.vue?vue&type=script&setup=true&lang=js"

import "./SelectCompaniesDialog.vue?vue&type=style&index=0&id=540e001e&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540e001e"]])

export default __exports__